import { startCase } from 'lodash-es';

// Datapoints required by the schema but excluded from mandatory validation checks.
// Kept in sync with notRequiredDatapoints in backend/domain/getMissingDataPoints.ts.
export const NOT_REQUIRED_DATAPOINT_PATTERNS = [
  /risk_details\.premium\.\d+\.premium_matrix\.general\.adjustable/,
  /risk_details\.premium\.\d+\.premium_matrix\.general\.discount/,
  /risk_details\.premium\.\d+\.premium_matrix\.general\.premium_type/,
  /risk_details\.premium_payment_terms\.\d+\.is_payment_terms_required/,
  /security_details\.order_hereon\.\d+\.broker_share\.broker_share\.broker_share_type/,
  /security_details\.order_hereon\.\d+\.order\.order\.order_type/,
  /subscription_agreement\.settlement_details\.\d+\.split_by_instalments/,
  /risk_details\.discounts\.\d+\.commission\.\d+\.commission\.commission\.amount_or_percentage/,
  /risk_details\.discounts\.\d+\.deduction\.\d+\.deduction\.deduction\.amount_or_percentage/,
  /risk_details\.discounts\.\d+\.discount\.\d+\.discount\.discount\.amount_or_percentage/,
];

export const isExcludedFromMandatoryCheck = (id: string): boolean =>
  NOT_REQUIRED_DATAPOINT_PATTERNS.some((pattern) => pattern.test(id));

export const formatMissingDataId = (id: string): string => {
  const splitByPart = id.replaceAll('_', ' ').split('.');
  if (splitByPart.length > 2 && splitByPart[1] !== 'sections' && splitByPart[2].match(/^[0-9]+$/)) {
    const index = splitByPart[2];
    if (index === '0') {
      splitByPart.splice(2, 1);
    } else {
      splitByPart[2] = `Section ${+index + 1}`;
    }
  }

  return splitByPart
    .filter((part) => !part.toLocaleLowerCase().endsWith('matrix'))
    .map(startCase)
    .join(' > ');
};
